var App = App || {};

App.WidgetTabbedCarousel = (function ($) {
    'use strict';

    const controlsTabbedCarousel = $(".widget-tabbed-carousel .widget-tabbed-carousel-list button");

    function Init(selector) {
        selector.each(function () {
            Swipe($(this));
        });

        controlsTabbedCarousel.on("click", function () {
            TabCarouselActivate($(this));
        }).on("keydown", function (e) {
            TabCarouselKeydown($(this), e);
        });
    }


    function TabCarouselActivate(elem) {

        const control = elem;
        const controlSiblings = control.parents("li").siblings("li").find("button");

        control.attr("aria-selected", true);
        controlSiblings.attr("aria-selected", false);

        const tabbedCarouselItem = $(`#${elem.attr("aria-controls")}`);
        const tabbedCarouselItemSiblings = tabbedCarouselItem.siblings(".tabbed-carousel-item");

        tabbedCarouselItem.stop().removeClass("fadeOut").fadeIn(350);
        tabbedCarouselItemSiblings.stop().addClass("fadeOut").fadeOut(350, function () {
            $(this).removeClass("fadeOut")
        });
    }

    function TabCarouselKeydown(tabbedCarouselItem, e) {

        const arrowsNext = ["ArrowRight", "ArrowDown"];
        const arrowsPrev = ["ArrowLeft", "ArrowUp"];

        if ([...arrowsNext, ...arrowsPrev].includes(e.key)) {

            let tabbedCarouselItemWhich;

            if (arrowsNext.includes(e.key)) {
                e.preventDefault();
                tabbedCarouselItemWhich = tabbedCarouselItem.parents("li").is(":last-child")
                    ? tabbedCarouselItem.parents("ul").children("li:first").find("button")
                    : tabbedCarouselItem.parents("li").next("li").find("button");
            }
            else if (arrowsPrev.includes(e.key)) {
                e.preventDefault();
                tabbedCarouselItemWhich = tabbedCarouselItem.parents("li").is(":first-child")
                    ? tabbedCarouselItem.parents("ul").children("li:last").find("button")
                    : tabbedCarouselItem.parents("li").prev("li").find("button");
            }

            tabbedCarouselItemWhich.removeAttr("tabindex").focus();
            tabbedCarouselItemWhich.parents("li").siblings("li").children("button").attr("tabindex", "-1")
            TabCarouselActivate(tabbedCarouselItemWhich);
        }
    }

    function Swipe($tabbedCarousel) {

        const speed = 0;
        const $mask = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-mask');
        const $scroll = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-scroll');
        const $content = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-content');
        const $focus = $tabbedCarousel.find('.widget-tabbed-carousel__swipe-content *');


        // help if content element is focused on while outside of view
        $focus.on('focus', function () {
            if ($(this).position().left + $(this).outerWidth() > $mask.width()) {
                $scroll.stop().animate({
                    scrollLeft: $(this).offset().left + $(this).outerWidth() - $mask.width() + $scroll.scrollLeft() + 36
                }, speed * 2);
            }

            if ($(this).position().left < 0) {
                $scroll.stop().animate({
                    scrollLeft: $(this).offset().left + $scroll.scrollLeft() - 78
                }, speed * 2);
            }
        });
    }



    return {
        Init: Init
    };

})(jQuery);